import Login from './views/Login.vue'
import NotFound from './views/404.vue'
import zhibodaping from './views/zhibodaping.vue'
import Home from './views/Home.vue'

import shouye from './views/pages/shouye/shouye.vue'
import zhibo from './views/pages/zhibo/zhibo.vue'
import zhibojilu from './views/pages/zhibojilu/zhibojilu.vue'
import wode from './views/pages/wode/wode.vue'
import zhibojian from './views/pages/zhibojian/zhibojian.vue'
import bofangshipin from './views/pages/bofangshipin/bofangshipin.vue'
import liushuijilu from './views/pages/liushuijilu/liushuijilu.vue'
import zhibozhongxin from './views/pages/zhibozhongxin/zhibozhongxin.vue'
import huifang from './views/pages/huifang/huifang.vue'
import tijiaoshenqing from './views/pages/tijiaoshenqing/tijiaoshenqing.vue'
import shenqingjilu from './views/pages/shenqingjilu/shenqingjilu.vue'
import zhibojinyao from './views/pages/zhibojinyao/zhibojinyao.vue'
import youjiantongzhi from './views/pages/youjiantongzhi/youjiantongzhi.vue'
import kaishizhibo from './views/pages/kaishizhibo/kaishizhibo.vue'
import zhiboshangpin from './views/pages/zhiboshangpin/zhiboshangpin.vue'
import zhibozhong from './views/pages/zhibozhong/zhibozhong.vue'
import wodequanbao from './views/pages/wodequanbao/wodequanbao.vue'
import chongzhierweima from './views/pages/chongzhierweima/chongzhierweima.vue'
import chongzhichenggong from './views/pages/chongzhichenggong/chongzhichenggong.vue'
import querentbi from './views/pages/querentbi/querentbi.vue'
import wodeqianbao from './views/pages/wodeqianbao/wodeqianbao.vue'
import yonghuzhuye from './views/pages/yonghuzhuye/yonghuzhuye.vue'


let routes = [
    {
        path: '/login',
        component: Login,
        name: '',
        hidden: true
    },
    {
        path: '/404',
        component: NotFound,
        name: '',
        hidden: true
    },
	{
	    path: '/',
	    component: Home,
	    name: '首页',
	    leaf: true,//只有一个节点
	    iconCls: 'https://ahhzy.oss-cn-hangzhou.aliyuncs.com/ldmgc/17670575807654.undefined',
	    selectedIconCls:'https://unishow-live-1383640469.cos.ap-hongkong.myqcloud.com/webStorage/web_17824522768521047.png',
	    children: [
	        { path: '/shouye', component: shouye, name: '首页',meta:{CnName:'首页',EnName:'Home',TwName:'首頁',JaName:'ホーム',KoName:'홈',keepAlive:true} },
	    ]
	},
	{
	    path: '/',
	    component: Home,
	    name: '直播',
	    leaf: true,//只有一个节点
	    iconCls: 'https://ahhzy.oss-cn-hangzhou.aliyuncs.com/ldmgc/17670576515180.undefined',
	    selectedIconCls:'https://unishow-live-1383640469.cos.ap-hongkong.myqcloud.com/webStorage/web_17824522983621238.png',
	    children: [
	        { path: '/zhibojilu', component: zhibojilu, name: '直播',meta:{CnName:'直播',EnName:'Live',TwName:'直播',JaName:'ライブ',KoName:'라이브'} },
	    ]
	},
	{
	    path: '/',
	    component: Home,
	    name: '我的',
	    leaf: true,//只有一个节点
	    iconCls: 'https://ahhzy.oss-cn-hangzhou.aliyuncs.com/ldmgc/17670576903559.undefined',
	    selectedIconCls:'https://ahhzy.oss-cn-hangzhou.aliyuncs.com/ldmgc/1767057707558124.undefined',
	    children: [
	        { path: '/wode', component: wode, name: '我的' ,meta:{CnName:'我的',EnName:'My',TwName:'我的',JaName:'マイページ',KoName:'마이페이지'}},
	    ]
	},
    {
        path: '/',
        component: Home,
        name: '',
        hidden: true,
        children: [
           { path: '/liushuijilu', component: liushuijilu, name: 'liushuijilu', hidden: true },
           { path: '/zhibozhongxin', component: zhibozhongxin, name: 'zhibozhongxin', hidden: true },
           { path: '/huifang', component: huifang, name: 'huifang', hidden: true },
           { path: '/tijiaoshenqing', component: tijiaoshenqing, name: 'tijiaoshenqing', hidden: true },
           { path: '/shenqingjilu', component: shenqingjilu, name: 'shenqingjilu', hidden: true },
           { path: '/zhibojinyao', component: zhibojinyao, name: 'zhibojinyao', hidden: true },
           { path: '/youjiantongzhi', component: youjiantongzhi, name: 'youjiantongzhi', hidden: true },
           { path: '/kaishizhibo', component: kaishizhibo, name: 'kaishizhibo', hidden: true },
           { path: '/zhiboshangpin', component: zhiboshangpin, name: 'zhiboshangpin', hidden: true },
           { path: '/zhibozhong', component: zhibozhong, name: 'zhibozhong', hidden: true },
           { path: '/wodequanbao', component: wodequanbao, name: 'wodequanbao', hidden: true },
           { path: '/chongzhierweima', component: chongzhierweima, name: 'chongzhierweima', hidden: true },
           { path: '/chongzhichenggong', component: chongzhichenggong, name: 'chongzhichenggong', hidden: true },
           { path: '/querentbi', component: querentbi, name: 'querentbi', hidden: true },
		   { path: '/wodeqianbao', component: wodeqianbao, name: 'wodeqianbao', hidden: true },
		   { path: '/yonghuzhuye', component: yonghuzhuye, name: 'yonghuzhuye', hidden: true },
		   { path: '/bofangshipin', component: bofangshipin, name: 'bofangshipin', hidden: true }
        ]
    },
    {
        path: '/zhibojian',
        name: 'zhibojian', // 路由名称
        component: zhibojian, // 新页面组件
    	hidden: true
    },
    {
        path: '*',
        hidden: true,
        redirect: { path: '/404' }
    }
];

export default routes;


// WEBPACK FOOTER //
// ./src/routes.js